import type { ShowData, APIResponse } from "./types";

export const fetchEnrichedShowData = async (show: ShowData): Promise<ShowData | null> => {
  try {
    let url: string;
    if (show.resourceType === "SERIES") {
      const seasonNum = show?.seasons?.[0]?.seasonNumber;
      url = `/uf/api/catalog/series/${show.resourceId}${
        seasonNum !== undefined ? `?season=${encodeURIComponent(seasonNum)}` : ''}`;
    } else if (show.resourceType === "CONTENT") {
      url = `/uf/api/catalog/program/${show.resourceId}`;
    } else {
      return null;
    }

    const response = await fetch(url);
    if (!response.ok) {
      return null;
    }
    const data: APIResponse = await response.json();

    if (show.resourceType === "SERIES") {
      const episode = data?.season?.contents?.[0] as ShowData | undefined;
      if (!episode) {
        return null;
      }
      // Server package enrichment (WAT-11211) sits at the ROOT of the series
      // response — carry it onto the episode the modal joins on.
      const { packages, channels } = data as unknown as ShowData;
      return {
        ...episode,
        packages,
        channels
      };
    }
    return (data as unknown as ShowData) || null;
  } catch (error) {
    console.error("Error fetching enriched show data:", error);
    return null;
  }
};

export const needsEnrichment = (show: ShowData): boolean => !show?.consumables || show.consumables.length === 0;
